import { LoaderFunction } from 'react-router-dom';

// Sentry
import * as Sentry from '@sentry/react';

// Schema
//import { newCommunicationSchema } from '../../../../../components/forms/NewCommunicationForm/schema';

// Types
import { AuthContextType } from '../../../../../../hooks/useAuth';

// GraphQL
import { client } from '../../../../../../gql/client';
import { selectAccidentByOrderId } from '../../../../../../gql/selectors/accidents';
import { FETCH_PREDEFINED_ORDERS } from '../../../../../../gql/queries/orders/predefinedData';
import debug from 'debug';

const loadAccidentSummary = async (
  orderID: string,
  userData: AuthContextType | null
) => {
  const logLoader = debug('rois:loader:accident-summary');
  debug.enable('rois:loader:accident-summary');
  debug.enable('rois:selector:accident'); // ✅ Activar logs del selector también
  logLoader(
    `🔍 Iniciando carga de resumen de accidente para orderID: ${orderID}`
  );

  try {
    logLoader(
      `👤 Usuario: ${userData?.user?.user?.name} ${userData?.user?.user?.surName}`
    );

    const startTime = performance.now();
    // Fetch accident data and predefinedOrders in parallel
    const [orderAccidentData, { data: { predefinedOrders } }] = await Promise.all([
      selectAccidentByOrderId(orderID),
      client.query({ query: FETCH_PREDEFINED_ORDERS }),
    ]);
    const endTime = performance.now();

    logLoader(
      `⏱️ Selector completado en ${(endTime - startTime).toFixed(2)}ms`
    );
    logLoader(`📊 Datos obtenidos: ${orderAccidentData ? 'OK' : 'NULL'}`);
    logLoader(`📋 PredefinedOrders cargados: ${predefinedOrders?.length || 0}`);

    if (orderAccidentData) {
      logLoader(
        `🚗 Vehículos en resultado: ${orderAccidentData.vehicles?.length || 0}`
      );
      logLoader(
        `🖼️ Imágenes en resultado: ${orderAccidentData.images?.length || 0}`
      );
      logLoader(`📋 Estado del accidente: ${orderAccidentData.state}`);
      logLoader(`📋 Predefine: ${orderAccidentData.predefine || 'N/A'}`);
    }

    const result = {
      ...orderAccidentData,
      predefinedOrders, // ✅ FIX: Añadir predefinedOrders para mostrar en WorkOrder
      operator: `${userData?.user?.user?.name} ${
        userData?.user?.user?.surName.split(' ')[0]
      }`,
    };

    logLoader(`✅ loadAccidentSummary completado exitosamente`);
    return result;
  } catch (err) {
    logLoader(`❌ Error en loadAccidentSummary:`, err);
    Sentry.captureException(err);
    console.log('> Communication Summary General View loading error:', err);
    return false;
  }
};
export const LoaderGeneralViewAccidentSummary: (
  userData: AuthContextType | null
) => LoaderFunction =
  (userData) =>
  async ({ params }) => {
    const logLoaderFunction = debug('rois:loader-function:accident-summary');
    logLoaderFunction(`🔍 LoaderFunction iniciado para params:`, params);

    if (!params.id) {
      logLoaderFunction(`❌ No hay params.id, retornando null`);
      return null;
    }

    const cacheSize = Object.keys(client.cache.extract()).length;
    logLoaderFunction(`📊 Tamaño de caché: ${cacheSize} entradas`);

    if (cacheSize === 0) {
      logLoaderFunction(`❌ Caché vacía, retornando null`);
      return null;
    }

    logLoaderFunction(`✅ Condiciones válidas, llamando a loadAccidentSummary`);
    const loaderToResolve = await loadAccidentSummary(params.id, userData);

    logLoaderFunction(
      `📦 Resultado del loader: ${loaderToResolve ? 'OK' : 'NULL/FALSE'}`
    );
    const result = { data: loaderToResolve };
    logLoaderFunction(`🎯 Retornando defer con data`);

    return result;
  };
